import type { IconNode } from '../types';

/**
 * @name copy-image
 * @description Lucide Lab SVG icon node.
 *
 * @preview ![img](data:image/svg+xml;base64,PHN2ZyAgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIgogIHdpZHRoPSIyNCIKICBoZWlnaHQ9IjI0IgogIHZpZXdCb3g9IjAgMCAyNCAyNCIKICBmaWxsPSJub25lIgogIHN0cm9rZT0iIzAwMCIgc3R5bGU9ImJhY2tncm91bmQtY29sb3I6ICNmZmY7IGJvcmRlci1yYWRpdXM6IDJweCIKICBzdHJva2Utd2lkdGg9IjIiCiAgc3Ryb2tlLWxpbmVjYXA9InJvdW5kIgogIHN0cm9rZS1saW5lam9pbj0icm91bmQiCj4KICA8cGF0aCBkPSJNNCAxNmEyIDIgMCAwIDEtMi0yVjRhMiAyIDAgMCAxIDItMmgxMGEyIDIgMCAwIDEgMiAyIiAvPgogIDxyZWN0IHdpZHRoPSIxNCIgaGVpZ2h0PSIxNCIgeD0iOCIgeT0iOCIgcng9IjIiIC8+CiAgPGNpcmNsZSBjeD0iMTQiIGN5PSIxNCIgcj0iMiIgLz4KICA8cGF0aCBkPSJtMTMuNCAyMiA0LjctMy45Yy44LS44IDItLjggMi44IDBsMS4xIDEuMSIgLz4KPC9zdmc+Cg==) - https://lucide.dev/icons/copy-image
 * @see https://lucide.dev/guide/packages/lucide - Documentation
 *
 * @returns {Array}
 *
 */
const copyImage: IconNode = [
  ['path', { d: 'M4 16a2 2 0 0 1-2-2V4a2 2 0 0 1 2-2h10a2 2 0 0 1 2 2', key: '1qd6ae' }],
  ['rect', { width: '14', height: '14', x: '8', y: '8', rx: '2', key: 'oyuw8j' }],
  ['circle', { cx: '14', cy: '14', r: '2', key: 'apkx28' }],
  ['path', { d: 'm13.4 22 4.7-3.9c.8-.8 2-.8 2.8 0l1.1 1.1', key: '11uwtb' }],
];

export default copyImage;
